import React from 'react';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import OfficeService from '../Services/OfficeService';

export default class ClientInvoiceItem {
  constructor(item) {
    if (item === undefined) {
      this.CiId = '';
      this.CiCcid = '';
      this.CiCcname = '';
      this.CiInvNum = '';
      this.CiDate = '';
      this.CiCfid = '';
      this.CiCount = '';
      this.CiTotal = '';
      this.CiUsid = '';
      this.CiMod = '';
      this.CiSentStatus = '';
      this.CiPrintid = '';
      this.CiPrintdt = '';
      this.CiEmailid = '';
      this.CiEmaildt = '';
      this.CiStatus = '';
      this.CiYrmo = '';
      this.CiEmailComment = '';
      this.CiBtid = '';
      this.CiRcyid = '';
      this.CiInvoiceDueDate = '';
      this.CiInternalReferenceNumber = '';
      this.CiApplyVattoFee = '';
      this.CiApplyVattoReimb = '';
      this.CiApplyVattoTravel = '';
      this.CiApplyVattoGaming = '';
      this.CiApplyVattoMisc = '';
      this.CiApplyVattoCredit = '';
      this.CiApplyVattoLateFee = '';
      this.CiBillToAddressName = '';
      this.CiBillToAddressState = '';
      this.CiBillToAddressLine1 = '';
      this.CiBillToAddressPostalCode = '';
      this.CiBillToAddressLine2 = '';
      this.CiBillToAddressCountry = '';
      this.CiBillToAddressCity = '';
      this.CiBillToAddressTypeCode = '';
      this.CiBillToContactFirstName = '';
      this.CiBillToContactLastName = '';
      this.CiBillToContactSalutation = '';
      this.CiPaymentTermsCode = '';
      this.CiInterestRate = '';
      this.CiDaysToPay = '30';
      this.CiInvoicedOn = '';
      this.CiFinalizedOn = '';
      this.CiLateDays = '';
      this.CiInvoiceLateOn = '';
      this.CiCurrentTotalDue = '';
      this.CiLateFees = '';
      this.CiPaid = '';
      this.CiCredit = '';
      this.CiInvoiceTotal = '';
      this.CiVat = '';
      this.CiTaxableTotal = '';
      this.CiInvoiceNumber = '';
      this.CiVatnumber = '';
      this.CiPonumber = '';
      this.CiInvoiceComment = '';
      this.CiVatpercent = '';
      this.CiStatusCode = '';
      this.CiRcyrate = '';
      this.CiRcyrateinv = '';
      this.CiCurrencyConversionMethod = '';
      this.CiBillToClientName = '';
      this.CiBillToClientPhone = '';
      this.CiDefaultReportName = '';
      this.CiReportGroup1 = '';
      this.CiReportGroup2 = '';
      this.CiReportOrder = '';
      this.CiCreditFinalized = '';
      this.CiCurrentTotalDueInvoice = '';
      this.CiVersion = '';
      this.CiCreditAmountFinalized = '';
      this.CiCreditVatfinalized = '';
      this.CiVatfinalized = '';
      this.CiOfficeId = '';
      this.CreatedOn = '';
      this.CreatedBy = '';
      this.ModifiedOn = '';
      this.ModifiedBy = '';
      this.OfficeAddressLine1 = '';
      this.OfficeAddressLine2 = '';
      this.OfficeAddressCity = '';
      this.OfficeAddressState = '';
      this.OfficeAddressPostalCode = '';
      this.OfficeAddressCountryName = '';
      this.OfficePhoneNumber = '';
      this.OfficeFaxNumber = '';
      this.OfficeAddressName = '';
      this.OfficeTaxNumber = '';
      this.FinanceContactName = '';
      this.FinanceContactPhone = '';
      this.FinanceContactEmail = '';
      this.OfficeBankInformation = '';
      this.CiFinalizedBy = '';
      this.SapinvoiceNumber = '';
      this.FulfillmentDate = '';
      this.ClientId = '';
      this.ServiceFeeId = '';
      this.ClientNameAndId = '';
    } else {
      this.CiId = item.ciId;
      this.CiCcid = item.ciCcid;
      this.CiCcname = item.ciCcname;
      this.CiInvNum = item.ciInvNum;
      this.CiDate = item.ciDate;
      this.CiCfid = item.ciCfid;
      this.CiCount = item.ciCount;
      this.CiTotal = item.ciTotal;
      this.CiUsid = item.ciUsid;
      this.CiMod = item.ciMod;
      this.CiSentStatus = item.ciSentStatus;
      this.CiPrintid = item.ciPrintid;
      this.CiPrintdt = item.ciPrintdt;
      this.CiEmailid = item.ciEmailid;
      this.CiEmaildt = item.ciEmaildt;
      this.CiStatus = item.ciStatus;
      this.CiYrmo = item.ciYrmo;
      this.CiEmailComment = item.ciEmailComment;
      this.CiBtid = item.ciBtid;
      this.CiRcyid = item.ciRcyid;
      this.CiInvoiceDueDate = item.ciInvoiceDueDate;
      this.CiInternalReferenceNumber = item.ciInternalReferenceNumber;
      this.CiApplyVattoFee = item.ciApplyVattoFee;
      this.CiApplyVattoReimb = item.ciApplyVattoReimb;
      this.CiApplyVattoTravel = item.ciApplyVattoTravel;
      this.CiApplyVattoGaming = item.ciApplyVattoGaming;
      this.CiApplyVattoMisc = item.ciApplyVattoMisc;
      this.CiApplyVattoCredit = item.ciApplyVattoCredit;
      this.CiApplyVattoLateFee = item.ciApplyVattoLateFee;
      this.CiBillToAddressName = item.ciBillToAddressName;
      this.CiBillToAddressState = item.ciBillToAddressState;
      this.CiBillToAddressLine1 = item.ciBillToAddressLine1;
      this.CiBillToAddressPostalCode = item.ciBillToAddressPostalCode;
      this.CiBillToAddressLine2 = item.ciBillToAddressLine2;
      this.CiBillToAddressCountry = item.ciBillToAddressCountry;
      this.CiBillToAddressCity = item.ciBillToAddressCity;
      this.CiBillToAddressTypeCode = item.ciBillToAddressTypeCode;
      this.CiBillToContactFirstName = item.ciBillToContactFirstName;
      this.CiBillToContactLastName = item.ciBillToContactLastName;
      this.CiBillToContactSalutation = item.ciBillToContactSalutation;
      this.CiPaymentTermsCode = item.ciPaymentTermsCode;
      this.CiInterestRate = item.ciInterestRate;
      this.CiDaysToPay = item.ciDaysToPay;
      this.CiInvoicedOn = item.ciInvoicedOn;
      this.CiFinalizedOn = item.ciFinalizedOn;
      this.CiLateDays = item.ciLateDays;
      this.CiInvoiceLateOn = item.ciInvoiceLateOn;
      this.CiCurrentTotalDue = item.ciCurrentTotalDue;
      this.CiLateFees = item.ciLateFees;
      this.CiPaid = item.ciPaid;
      this.CiCredit = item.ciCredit;
      this.CiInvoiceTotal = item.ciInvoiceTotal;
      this.CiVat = item.ciVat;
      this.CiTaxableTotal = item.ciTaxableTotal;
      this.CiInvoiceNumber = item.ciInvoiceNumber;
      this.CiVatnumber = item.ciVatnumber;
      this.CiPonumber = item.ciPonumber;
      this.CiInvoiceComment = item.ciInvoiceComment;
      this.CiVatpercent = item.ciVatpercent;
      this.CiStatusCode = item.ciStatusCode;
      this.CiRcyrate = item.ciRcyrate;
      this.CiRcyrateinv = item.ciRcyrateinv;
      this.CiCurrencyConversionMethod = item.ciCurrencyConversionMethod;
      this.CiBillToClientName = item.ciBillToClientName;
      this.CiBillToClientPhone = item.ciBillToClientPhone;
      this.CiDefaultReportName = item.ciDefaultReportName;
      this.CiReportGroup1 = item.ciReportGroup1;
      this.CiReportGroup2 = item.ciReportGroup2;
      this.CiReportOrder = item.ciReportOrder;
      this.CiCreditFinalized = item.ciCreditFinalized;
      this.CiCurrentTotalDueInvoice = item.ciCurrentTotalDueInvoice;
      this.CiVersion = item.ciVersion;
      this.CiCreditAmountFinalized = item.ciCreditAmountFinalized;
      this.CiCreditVatfinalized = item.ciCreditVatfinalized;
      this.CiVatfinalized = item.ciVatfinalized;
      this.CiOfficeId = item.ciOfficeId;
      this.CreatedOn = item.createdOn;
      this.CreatedBy = item.createdBy;
      this.ModifiedOn = item.modifiedOn;
      this.ModifiedBy = item.modifiedBy;
      this.OfficeAddressLine1 = item.officeAddressLine1;
      this.OfficeAddressLine2 = item.officeAddressLine2;
      this.OfficeAddressCity = item.officeAddressCity;
      this.OfficeAddressState = item.officeAddressState;
      this.OfficeAddressPostalCode = item.officeAddressPostalCode;
      this.OfficeAddressCountryName = item.officeAddressCountryName;
      this.OfficePhoneNumber = item.officePhoneNumber;
      this.OfficeFaxNumber = item.officeFaxNumber;
      this.OfficeAddressName = item.officeAddressName;
      this.OfficeTaxNumber = item.officeTaxNumber;
      this.FinanceContactName = item.financeContactName;
      this.FinanceContactPhone = item.financeContactPhone;
      this.FinanceContactEmail = item.financeContactEmail;
      this.OfficeBankInformation = item.officeBankInformation;
      this.CiFinalizedBy = item.ciFinalizedBy;
      this.SapinvoiceNumber = item.sapinvoiceNumber;
      this.FulfillmentDate = item.fulfillmentDate;
      this.ClientNameAndId = `${item.ciCcname} (${item.ciCcid})`;
      this.Selected = false;
    }
  }

  static NameOfTheIdField() {
    return 'CiId';
  }

  static nameOfTheItemDetailList() {
    return 'Invoices';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = [];
  static BoolFields = [];

  static FieldsToShowInListTable = [];

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Selected',
        orderById: '',
        data: ClientInvoiceItem.getSelectedCellContent,
        type: FieldTypesEnum.PureDataField,
        minWidth: 20,
      },
      {
        label: 'BARE #',
        orderById: 'CiId',
        data: 'CiId',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Client #',
        orderById: 'CiCcname',
        data: 'ClientNameAndId',
        type: FieldTypesEnum.PureDataField,
        minWidth: 140,
      },
      {
        label: 'PO #',
        orderById: 'CiPonumber',
        data: 'CiPonumber',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Invoiced On',
        orderById: 'FormattedCiDate',
        data: 'FormattedCiDate',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Items',
        orderById: 'CiCount',
        data: 'CiCount',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Internal Reference',
        orderById: 'CiInternalReferenceNumber',
        data: 'CiInternalReferenceNumber',
        type: FieldTypesEnum.PureDataField,
      },
    ];
  }

  static getSelectedCellContent(item) {
    return (
      <div className='text-center'>
        <input
          type='checkbox'
          checked={item.Selected}
          onChange={(e) => {
            ClientInvoiceItem.clickOnSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }
}
